import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

function Sidebar({ links, isOpen, onClose }) {
  const location = useLocation();

  useEffect(() => {
    if (onClose) {
      onClose();
    }
    // Chiude il menu mobile al cambio pagina
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  return (
    <>
      <div
        className={`app-sidebar-overlay${isOpen ? " is-open" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        id="app-sidebar"
        className={`app-sidebar${isOpen ? " is-open" : ""}`}
        aria-label="Menu di navigazione"
      >
        <div className="app-sidebar-header d-lg-none">
          <span className="app-sidebar-title">Menu</span>
          <button
            type="button"
            className="app-sidebar-close"
            onClick={onClose}
            aria-label="Chiudi menu"
          >
            <svg className="icon icon-sm">
              <use href={`${iconSprite}#it-close`} />
            </svg>
          </button>
        </div>
        <nav>
          <ul className="app-sidebar-nav">
            {links &&
              links.map((linkObb, index) => (
                <li key={`${linkObb.url}-${index}`}>
                  <NavLink
                    to={linkObb.url}
                    className="app-sidebar-link"
                    activeClassName="active"
                    exact={linkObb.url === "/"}
                  >
                    {linkObb.testo}
                  </NavLink>
                </li>
              ))}
          </ul>
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
